import { render, staticRenderFns } from "./MembersSelector.vue?vue&type=template&id=70080c89&"
import script from "./MembersSelector.vue?vue&type=script&lang=js&"
export * from "./MembersSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports